module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"download":"Download","noDataToExport":"No data to export","noFieldsSubmittedForExport":"No fields have been submitted for export."}}')
  delete Component.options._Ctor
}
